let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("izd5I")).then(() => parcelRequire('i3X2T'));